export const setIsSuperAdmin = isSuperAdmin => ({
	type: 'SET_IS_SUPER_ADMIN',
	isSuperAdmin: Boolean(isSuperAdmin)
});
